package com.speedsoftware.nibbler

import androidx.compose.runtime.Composable
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.speedsoftware.nibbler.ui.theme.NibblerColors
import androidx.compose.runtime.remember
import androidx.compose.ui.tooling.preview.Preview
import com.speedsoftware.nibbler.ui.AppState
import com.speedsoftware.nibbler.ui.Screen
import com.speedsoftware.nibbler.ui.admin.AdminDashboardScreen
import com.speedsoftware.nibbler.ui.auth.AcceptInviteScreen
import com.speedsoftware.nibbler.ui.auth.ForgotPasswordScreen
import com.speedsoftware.nibbler.ui.auth.LoginScreen
import com.speedsoftware.nibbler.ui.boards.ProjectBoardScreen
import com.speedsoftware.nibbler.ui.settings.SettingsScreen
import com.speedsoftware.nibbler.ui.projects.ProjectsScreen
import com.speedsoftware.nibbler.ui.components.LocalApiClient
import com.speedsoftware.nibbler.ui.theme.NibblerTheme

@Composable
@Preview
fun App() {
    val appState = remember { AppState() }

    LaunchedEffect(Unit) { appState.restoreSession() }

    CompositionLocalProvider(LocalApiClient provides appState.apiClient) {
    NibblerTheme {
        if (appState.isRestoringSession) {
            // Checking for an existing session: show nothing but the background instead of flashing the login form
            Box(modifier = Modifier.fillMaxSize().background(NibblerColors.DarkBackground))
            return@NibblerTheme
        }
        // Text on the account and settings screens can be selected and copied (the boards keep their drag and drop)
        when (val screen = appState.currentScreen) {
            is Screen.ProjectsList -> ProjectsScreen(appState = appState)
            is Screen.ProjectDetail -> ProjectBoardScreen(appState = appState, initialProject = screen.project)
            else -> SelectionContainer {
                when (screen) {
                    is Screen.Login -> LoginScreen(appState = appState)
                    is Screen.AcceptInvite -> AcceptInviteScreen(appState = appState, token = screen.token)
                    is Screen.ResetPassword -> ForgotPasswordScreen(appState = appState, token = screen.token)
                    is Screen.AdminDashboard -> AdminDashboardScreen(appState = appState)
                    is Screen.Settings -> SettingsScreen(appState = appState, section = screen.section)
                    else -> Unit
                }
            }
        }
    }
    }
}